<div style="border-radius: 10px !important;">
  <!--Header-->
  <div class="modal-header" style="border-bottom: none;padding-bottom: 0px;padding-left: 15px;background-color: #F1F1F0 ;border-radius: 10px 10px 0px 0px;">
    <div class="col-md-12 col-12 col-xs-12" style="display: flex; justify-content: space-between; padding: 0px;align-items: center; ">
      <div class="col-md-10 col-5 col-sm-10 pad0 inLneBlk newHeader " style="vertical-align: top; padding: 0px;">
        <span id="ApntmntHdr" style="font-size: 20px; font-weight: 500; color: #333333;">GST Ledger Configuration</span>
      </div>
      <span style="padding: 0px 0px !important; top: -6px;">  
        <i class="closeMdl zmdi zmdi-close Marginbtm" (click)="closeModal()"></i>
      </span>
    </div>
  </div>

  <!--Body-->
  <div class="modal-body" style="padding: 10px 20px 20px 20px; background-color: #F1F1F0; overflow-y: auto;">
    <!-- GST Locations -->
    <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 15px;" *ngIf="eGST">
      <span style="font-size: 12px; color: #E88421;">
        GST :
      </span>
      <select class="form-control formCtlFltr" [(ngModel)]="gstINLocation" (ngModelChange)="getGSTLedgers()"
        style="display: inline-block; width: 200px; cursor: pointer;">
          <option *ngFor="let g of gstLocation" [ngValue]="g.GST">{{g.GST}}</option>
      </select>
    </div>

    <div class="col-md-12 col-sm-12 col-12 pad0">
      <!-- GST Out (Sales) -->
      <div class="col-md-4 col-sm-12 col-12 pad0" style="display: inline-block;padding-right: 15px;">
        <div style="margin-bottom: 7px;">
          <span style="font-size: 16px;">Sales (Output)</span>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 10px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST-Out :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.cgstOut" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12 pad0 " style="margin-bottom: 7px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST-Out :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.sgstOut" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 7px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST-Out :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.igstOut" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>
      </div>

      <!-- GST In (Purchase) webview -->
      <div class="col-md-4 col-sm-12 col-12 webView" style="display: inline-block;">
        <div style="margin-bottom: 7px;">
          <span style="font-size: 16px;">Purchase (Input)</span>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 7px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST-In :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.csgtIn" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 7px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST-In :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.sgstIn" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 7px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST-In :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.igstIn" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>
      </div>

      <!-- GST In (Purchase) mobview -->
      <div class="col-md-4 col-sm-12 col-12 mobView" style="padding: 0px 15px 0px 0px ;">
        <div style="margin-bottom: 7px;">
          <span style="font-size: 16px;" class="tealText">Purchase (Input)</span>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST-In :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.csgtIn" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST-In :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.sgstIn" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0 tealText" style="margin-bottom: 7px;">
          <div class="col-md-4 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST-In :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk" style="left: 3px;">
            <input class="form-control wid100 bzInput" list="cgstOut" [(ngModel)]="gstLedger.igstIn" placeholder="Select"
              [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important" id="cgstOut">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>
      </div>

      <!-- GST Reverse (Reverse Charge) webview -->
      <div class="col-md-4 col-sm-12 col-12 pad0 webView" style="display: inline-block;padding-left: 15px;">
        <div style="margin-bottom: 7px;">
          <span style="font-size: 16px; font-weight: 500; margin-bottom: 7px;">Reverse Charge
            (Output)</span>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 10px;">
          <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="cgstOutRev" [(ngModel)]="gstLedger.cgstRevOut"
              placeholder="Select" [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important" id="cgstOutRev">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 7px;">
          <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="sgstOutRev" [(ngModel)]="gstLedger.sgstRevOut"
              placeholder="Select" [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="sgstOutRev">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0" style="margin-bottom: 7px;">
          <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="igstOutRev" [(ngModel)]="gstLedger.igstRevOut"
              placeholder="Select" [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="igstOutRev">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>
      </div>

      <!-- GST Reverse (Reverse Charge) mobView -->
      <div class="col-md-4 col-sm-12 col-12 pad0 mobView" style="padding:0px 15px 0px 0px;">
        <div style="margin-bottom: 7px;">
          <span style="font-size: 16px; font-weight: 500; margin-bottom: 7px;" class="blueText">Reverse Charge
            (Output)</span>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 10px;">
          <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> CGST :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="cgstOutRev" [(ngModel)]="gstLedger.cgstRevOut"
              placeholder="Select" [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important" id="cgstOutRev">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 7px;">
          <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> SGST :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="sgstOutRev" [(ngModel)]="gstLedger.sgstRevOut"
              placeholder="Select" [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="sgstOutRev">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0 blueText" style="margin-bottom: 7px;">
          <div class="col-md-3 col-sm-4 col-4 pad0 inLneBlk" style="line-height: 30px; font-size: 12px;"> IGST :
          </div>
          <div class="col-md-8 col-sm-8 col-8 pad0 inLneBlk">
            <input class="form-control wid100 bzInput" list="igstOutRev" [(ngModel)]="gstLedger.igstRevOut"
              placeholder="Select" [disabled]="disAllowGSTLedger">
            <datalist style="left: 5px !important;" id="igstOutRev">
              <option *ngFor="let l of ledgers" [value]="l.LedgerName">{{l.LedgerName}}</option>
            </datalist>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Footer-->
  <div class="modal-footer" style="background-color: #F1F1F0; border-top: none; border-radius: 0px 0px 10px 10px; padding: 0px 15px 15px 15px; display: flex; justify-content: flex-start; align-items: center;" *ngIf="!disAllowGSTLedger">
    <span class="btn-darkGreen brdrRadius3 btn-save" style="padding:2px 14px 2px; line-height: 1.66em; font-size: 14px;"
      (click)="saveGSTLedger()">
      <i class="fa fa-check" style="margin-right: 5px;"></i>
      <span>Save</span>
    </span>
    <span class="btn darkBlueButton" style="padding:2px 14px 2px !important; line-height: 1.66em; font-size: 14px; margin-left: 10px;"
      (click)="deLinkLedgers()" *ngIf="!acctDocLinked && gstLedgerList.length > 0">
      <i class="fa fa-unlink" style="margin-right: 5px;"></i>
      <span>De-link Ledgers</span>
    </span>
    <span style="font-size: 12px; color: #777; margin-left: 10px; font-style: italic;">Please note that change in this configuration will only be reflected in new vouchers.</span>
  </div>
</div>